module.exports = require("@pb/kit-component-scroll");